<template>
  <div>
    <v-dialog
      id="change-password-dialog"
      v-model="showDialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark color="red">
          <v-toolbar-title>Ubah Password</v-toolbar-title>
          <v-spacer />
          <v-btn icon dark @click="closeDialog()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="mt-5">
          <v-form v-model="valid" ref="form" lazy-validation>
            <v-text-field
              v-show="false"
              v-model="userName"
              label="user name"
              type="text"
              autocomplete="off"
            />
            <v-text-field
              v-model="newPassword"
              label="Password Baru"
              :type="showDialog ? 'password' : 'text'"
              :rules="rules.password"
              autocomplete="new-password"
              required
            />
            <v-text-field
              v-model="newPasswordCopy"
              label="Ulangi Password Baru"
              :type="showDialog ? 'password' : 'text'"
              :rules="rules.passwordCopy"
              autocomplete="new-password"
              required
            />
          </v-form>
        </v-card-text>
        <v-card-actions class="pa-2 mx-2">
          <v-btn
            color="red"
            :dark="valid"
            block
            :disabled="!valid"
            @click="changePassword"
          >
            Simpan
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Snackbar -->
    <v-snackbar v-model="snackbar.show" multi-line bottom>
      {{ snackbar.text }}
    </v-snackbar>
  </div>
</template>

<script>
import EzKasirAPI from "../../library/api";

const ChangePassword = {
  name: "ChangePassword",
  props: { showDialog: Boolean },
  data() {
    return {
      // showDialog: false,
      valid: false,
      userName: "",
      newPassword: "",
      newPasswordCopy: "",
      snackbar: {
        show: false,
        text: "",
      },
      rules: {
        password: [
          (v) => !!v || "Password wajib diisi",
          (v) => v.length >= 6 || "Password wajib diisi 6 karakter atau lebih",
        ],
        passwordCopy: [
          (v) => !!v || "Password wajib diisi",
          (v) => v.length >= 6 || "Password wajib diisi 6 karakter atau lebih",
          () =>
            this.newPassword === this.newPasswordCopy || "Password wajib sama",
        ],
      },
    };
  },
  methods: {
    closeDialog() {
      this.$emit("close-dialog");
    },
    async changePassword() {
      if (!this.$refs.form.validate()) return null;

      try {
        const url = `${process.env.VUE_APP_API_URL}/user/change-password`;
        await EzKasirAPI.put(url, { password: this.newPassword });

        this.snackbar.text = "Berhasil mengubah password.";
        localStorage.clear();
        this.closeDialog();

        setTimeout(() => {
          window.location.reload(true);
        }, 3000);
      } catch (e) {
        console.error(e);
        this.snackbar.text = "Gagal mengubah password.";
      }

      this.snackbar.show = true;
    },
  },
  watch: {
    showDialog() {
      if (!this.showDialog) return;

      this.valid = false;
      this.newPassword = "";
      this.newPasswordCopy = "";
    },
  },
};

export default ChangePassword;
</script>
